import { makeStyles } from 'tss-react/mui';
import { themeColors } from 'app/shared/theme/theme';

export const useStyles = makeStyles()(() => ({
  info: {
    width: 561 - 48,
    paddingBottom: 24,
    margin: '0px 24px',
    maxHeight: '85vh',
    overflow: 'auto',
  },
  subheader: {
    paddingBottom: 8,
    paddingTop: 16,
    borderBottom: `2px solid ${themeColors.greyscale4}`,
    marginBottom: 8,
  },
  sectionItem: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: 4,
  },
  valueContainer: {
    wordWrap: 'break-word',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  ageContainerLight: {
    padding: '4px 8px',
    borderRadius: 2,
    backgroundColor: themeColors.greyscale4_50,
    boxSizing: 'border-box',
    width: 'fit-content',
    marginLeft: 5,
  },
}));
